export default __webpack_public_path__ + "static/media/logo.008a84ff.svg";